import { Component, ElementRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate, AnimationEvent } from '@angular/animations';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { ResizeDirectionEnum } from '../../../Forms/components/TextareaInput/textarea-input.component';

@Component({
    selector: 'agpr-agent-banner',
    templateUrl: './agent-banner.component.html',
    styleUrls: ['./agent-banner.component.scss'],
    standalone: false,
    animations: [
        trigger('bannerContent', [
            state('hidden', style({
                height: '0',
                opacity: 0
            })),
            state('visible', style({
                height: '*',
                opacity: 1
            })),
            transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AgentBannerComponent {
    @Input() id: string;
    @Input() naturalLanguagePrompt: string = '';
    @Input() headerTitle: string = '';
    @Input() placeholder: string = 'Monitoring.search.prcopilot.placeholder';
    @Input() showExpandButton: boolean = true;
    // Submit button tooltip: shown when a prompt has been entered (the actionable state).
    @Input() submitTooltip: string = 'Monitoring.search.prcopilot.submitTooltip';
    // Submit button tooltip: shown when the prompt is empty (the disabled state).
    @Input() submitTooltipEmpty: string = 'Monitoring.search.prcopilot.submitTooltipEmpty';
    @Output() naturalLanguagePromptChange = new EventEmitter<string>();


    // Agent debug inputs
    @Input() hasAgentDebug: boolean = false;
    @Input() taskDescription: string = '';
    @Output() taskDescriptionChange = new EventEmitter<string>();
    @Input() systemPrompt: string = '';
    @Output() systemPromptChange = new EventEmitter<string>();
    @Input() topicSystemPrompt: string = '';
    @Output() topicSystemPromptChange = new EventEmitter<string>();

    @Output() submit = new EventEmitter<string>();
    @Output() submitDirect = new EventEmitter<void>();

    @ViewChild('bannerContentWrapper') public bannerContentWrapper: ElementRef;

    agentBannerExpanded: boolean = true;
    animating: boolean = false;

    readonly buttonTypes = ButtonTypesEnum;
    readonly resizeEnum = ResizeDirectionEnum;

    toggle(): void {
        if (this.animating) {
            return;
        }
        this.animating = true;
        if (this.agentBannerExpanded) {
            this.agentBannerExpanded = false;
        } else {
            this.agentBannerExpanded = true;
            this.bannerContentWrapper.nativeElement.style.display = 'block';
        }
    }

    onToggleDone(event: AnimationEvent): void {
        this.animating = false;
        if (!this.agentBannerExpanded) {
            this.bannerContentWrapper.nativeElement.style.display = 'none';
        }
    }

    public submitClick(): void {
        this.submit.emit(this.naturalLanguagePrompt);
    }
}
